// Services data with SEO-optimized slugs and detailed information
export const servicesData = [
  {
    id: 'seo',
    slug: 'search-engine-optimization',
    title: 'Search Engine Optimization (SEO)',
    shortDesc: 'Boost your visibility on Google, Bing, and Yahoo with white hat SEO strategies for organic growth.',
    metaTitle: 'Best SEO Company In Ramamurthy Nagar | SEO Services In Ramamurthy Nagar',
    metaDescription: 'Looking for the best SEO company in Ramamurthy Nagar? Cyborgsapient Pvt. Ltd. delivers result-driven SEO services to improve search rankings, traffic, and online visibility.',
    keywords: 'SEO services in Bangalore, SEO services in Ramamurthy Nagar, SEO company near me, best SEO company in Bangalore, best SEO company in Ramamurthy Nagar, local SEO services Bangalore, local SEO services Ramamurthy Nagar, affordable SEO services Bangalore, affordable SEO services Ramamurthy Nagar, SEO expert in Bangalore, SEO expert in Ramamurthy Nagar, search engine optimization',
    icon: 'FaSearch',
    problem: 'Struggling with low search engine rankings? Your website might be invisible to potential customers searching for your products or services.',
    solution: 'Our comprehensive SEO services combine technical optimization, content strategy, and link building to improve your search visibility and drive qualified organic traffic.',
    features: [
      'Keyword Research & Strategy',
      'On-Page SEO Optimization',
      'Technical SEO Audit',
      'Link Building & Outreach',
      'Content Optimization',
      'Local SEO Services',
      'SEO Analytics & Reporting'
    ],
    results: 'Clients typically see 40-150% increase in organic traffic within 6-12 months with sustainable, long-term growth.',
    industryFocus: ['Healthcare', 'E-commerce', 'SaaS', 'Real Estate', 'Finance']
  },
  {
    id: 'google-ads',
    slug: 'google-ads',
    title: 'Google Ads',
    shortDesc: 'Reach targeted audiences effectively with personalized ad campaigns across Google\'s ad network.',
    metaTitle: 'Google Ads Company In Ramamurthy Nagar | Best Google Ads Agency In Ramamurthy Nagar',
    metaDescription: 'Looking for a trusted Google Ads company in Ramamurthy Nagar? We are a best-rated Google Ads agency delivering high-ROI PPC campaigns, leads, and conversions.',
    keywords: 'Google Ads agency Bangalore, Google Ads agency Ramamurthy Nagar, google ads company in bangalore, google ads company in ramamurthy nagar, best google ads agency in ramamurthy nagar, PPC services Bangalore, PPC services Ramamurthy Nagar, lead generation company Bangalore, lead generation company Ramamurthy Nagar',
    icon: 'FaGoogle',
    problem: 'Wasting ad spend on irrelevant clicks? Your Google Ads campaigns need strategic optimization to reach the right audience.',
    solution: 'Our Google Ads experts create data-driven campaigns with precise targeting, compelling ad copy, and continuous optimization to maximize ROI.',
    features: [
      'Campaign Strategy & Setup',
      'Keyword Research & Selection',
      'Ad Copy Creation & A/B Testing',
      'Landing Page Optimization',
      'Bid Management & Optimization',
      'Conversion Tracking Setup',
      'Performance Reporting'
    ],
    results: 'Average ROI improvement of 200-400% with reduced cost-per-acquisition and increased conversion rates.',
    industryFocus: ['E-commerce', 'Healthcare', 'Legal', 'Real Estate', 'Education']
  },
  {
    id: 'facebook-ads',
    slug: 'facebook-ads',
    title: 'Facebook Ads',
    shortDesc: 'Drive traffic and awareness using strategic creatives tailored to Meta\'s platform algorithms.',
    metaTitle: 'Best Facebook Ads Services In Ramamurthy Nagar | Top Meta Ads Marketing Agency In Ramamurthy Nagar',
    metaDescription: 'Cyborgsapient Pvt. Ltd. is a leading Facebook Ads marketing agency in Ramamurthy Nagar, offering high-ROI Meta Ads campaigns to generate leads, sales, and brand growth.',
    keywords: 'Facebook Ads Marketing Agency in Bangalore, best facebook ads services in ramamurthy nagar, top meta ads marketing agency in ramamurthy nagar, social media marketing Bangalore, social media marketing Ramamurthy Nagar, lead generation company Bangalore, lead generation company Ramamurthy Nagar',
    icon: 'FaFacebookF',
    problem: 'Your Facebook ads aren\'t converting? Without proper targeting and creative strategy, you\'re missing out on valuable customers.',
    solution: 'We leverage Facebook\'s advanced targeting capabilities and compelling creative strategies to reach your ideal audience and drive measurable results.',
    features: [
      'Audience Research & Targeting',
      'Creative Design & Development',
      'Campaign Setup & Optimization',
      'Retargeting Strategies',
      'Conversion Pixel Setup',
      'Lookalike Audience Creation',
      'Performance Analytics'
    ],
    results: 'Clients achieve 2-5x improvement in ROAS with better targeting and optimized ad creative.',
    industryFocus: ['E-commerce', 'Fashion', 'Beauty', 'Fitness', 'Entertainment']
  },
  {
    id: 'youtube-ads',
    slug: 'youtube-ads',
    title: 'YouTube Ads',
    shortDesc: 'Leverage video to capture attention with smart targeting and compelling storytelling.',
    metaTitle: 'Top YouTube Ads Agency In Ramamurthy Nagar | Video Marketing',
    metaDescription: 'Cyborgsapient Pvt. Ltd. is a top YouTube Ads agency in Ramamurthy Nagar, offering high-performance video marketing and YouTube advertising services to drive views, leads, and sales.',
    keywords: 'Top YouTube Ads Agency in Bangalore – Video Marketing, top youtube ads agency in ramamurthy nagar, video marketing ramamurthy nagar, PPC services Bangalore, PPC services Ramamurthy Nagar, video ads agency bangalore',
    icon: 'FaYoutube',
    problem: 'Video marketing is powerful, but creating effective YouTube ads requires expertise in both creative and technical execution.',
    solution: 'Our YouTube ad specialists combine compelling video creative with strategic targeting to maximize views, engagement, and conversions.',
    features: [
      'Video Ad Creative Development',
      'Campaign Strategy & Setup',
      'Audience Targeting',
      'Placement Optimization',
      'Bidding Strategy',
      'Video SEO Integration',
      'Performance Tracking'
    ],
    results: 'Average 3-7x improvement in video engagement rates and lower cost-per-view metrics.',
    industryFocus: ['Education', 'Entertainment', 'Technology', 'Fitness', 'Travel']
  },
  {
    id: 'sms-marketing',
    slug: 'sms-marketing',
    title: 'SMS Marketing',
    shortDesc: 'Deliver powerful CTAs through high-conversion mobile messages sent at the right moment.',
    metaTitle: 'SMS Marketing In Ramamurthy Nagar | Bulk SMS Marketing Services In Ramamurthy Nagar',
    metaDescription: 'Reach your audience instantly with bulk SMS marketing services in Ramamurthy Nagar. Cyborgsapient Pvt. Ltd. delivers fast, reliable, and affordable SMS campaigns.',
    keywords: 'sms marketing in Bangalore, sms marketing in ramamurthy nagar, bulk sms marketing services in ramamurthy nagar, lead generation company Bangalore, lead generation company Ramamurthy Nagar',
    icon: 'FaSms',
    problem: 'Email open rates are declining. You need a more direct channel to reach customers with time-sensitive offers.',
    solution: 'SMS marketing offers 98% open rates and instant delivery. We create targeted text campaigns that drive immediate action.',
    features: [
      'Campaign Strategy Development',
      'Audience Segmentation',
      'Automated Workflows',
      'Personalized Messaging',
      'Compliance Management',
      'Delivery Optimization',
      'Performance Analytics'
    ],
    results: 'Average conversion rates of 20-30% compared to 2-5% for email marketing.',
    industryFocus: ['Retail', 'Restaurants', 'Healthcare', 'Fitness', 'Events']
  },
  {
    id: 'email-marketing',
    slug: 'email-marketing',
    title: 'Email Marketing',
    shortDesc: 'Turn inboxes into a growth channel with beautifully designed, data-driven email campaigns.',
    metaTitle: 'Top Email Marketing Services In Ramamurthy Nagar | Cyborgsapient Pvt. Ltd.',
    metaDescription: 'Looking for reliable email marketing services in Ramamurthy Nagar? Cyborgsapient helps businesses grow with personalized campaigns, automation, and high-ROI strategies.',
    keywords: 'email marketing services in bangalore, top email marketing services in ramamurthy nagar, email marketing company bangalore, lead generation company Bangalore, lead generation company Ramamurthy Nagar',
    icon: 'FaEnvelope',
    problem: 'Low email open rates and conversions? Generic email campaigns fail to engage subscribers effectively.',
    solution: 'We design personalized, automated email campaigns that nurture leads and drive conversions through segmentation and strategic timing.',
    features: [
      'Email Template Design',
      'Automated Workflow Creation',
      'Audience Segmentation',
      'A/B Testing',
      'Deliverability Optimization',
      'Personalization',
      'Performance Analytics'
    ],
    results: 'Average 25-40% increase in open rates and 50-100% improvement in conversion rates.',
    industryFocus: ['E-commerce', 'SaaS', 'Education', 'Healthcare', 'Finance']
  },
  {
    id: 'content-marketing',
    slug: 'content-marketing',
    title: 'Content Marketing',
    shortDesc: 'Tell your brand story with SEO-optimized blogs, articles, and social media content.',
    metaTitle: 'Best Content Marketing Agency In Ramamurthy Nagar | Top Content Marketing Companies',
    metaDescription: 'Partner with Cyborgsapient Pvt. Ltd., a leading content marketing agency in Ramamurthy Nagar, offering SEO content, blogs, website copy, and content strategy services.',
    keywords: 'Best Content Marketing Agency in Bangalore, best content marketing agency in ramamurthy nagar, top content marketing companies, content strategy ramamurthy nagar, SEO expert in Bangalore, SEO expert in Ramamurthy Nagar',
    icon: 'FaFileAlt',
    problem: 'Creating quality content that ranks and converts requires consistent strategy, SEO expertise, and creative storytelling.',
    solution: 'Our content marketing services combine SEO best practices with engaging storytelling to attract, engage, and convert your target audience.',
    features: [
      'Content Strategy Development',
      'SEO-Optimized Blog Writing',
      'Content Calendar Planning',
      'Content Distribution',
      'Content Performance Analysis',
      'Editorial Planning',
      'Multimedia Content Creation'
    ],
    results: 'Average 3-5x increase in organic traffic and 40-60% improvement in engagement metrics.',
    industryFocus: ['B2B', 'Technology', 'Finance', 'Healthcare', 'Education']
  },
  {
    id: 'whatsapp-marketing',
    slug: 'whatsapp-marketing',
    title: 'WhatsApp Marketing',
    shortDesc: 'Connect with leads and customers in real time through personalized chat experiences.',
    metaTitle: 'Bulk WhatsApp Marketing Services In Ramamurthy Nagar | Bulk WhatsApp Marketing Service Providers',
    metaDescription: 'Cyborgsapient Pvt. Ltd. provides reliable WhatsApp marketing services in Ramamurthy Nagar, including bulk messaging, campaign management, and customer engagement solutions.',
    keywords: 'Whatsapp Marketing Company In Bangalore, bulk whatsapp marketing services in ramamurthy nagar, bulk whatsapp marketing service providers, lead generation company Bangalore, lead generation company Ramamurthy Nagar',
    icon: 'FaWhatsapp',
    problem: 'Customers expect instant communication. Traditional channels can\'t match the immediacy of messaging platforms.',
    solution: 'WhatsApp Business API enables automated, personalized conversations at scale, improving customer satisfaction and conversion rates.',
    features: [
      'WhatsApp Business API Setup',
      'Automated Message Flows',
      'Customer Support Integration',
      'Broadcast Campaigns',
      'Rich Media Messaging',
      'Chatbot Development',
      'Analytics & Reporting'
    ],
    results: 'Average 80% message read rate and 25-35% response rates, significantly higher than email.',
    industryFocus: ['Retail', 'Real Estate', 'Healthcare', 'Education', 'Hospitality']
  },
  {
    id: 'ecommerce-marketing',
    slug: 'ecommerce-marketing',
    title: 'E-commerce Marketing',
    shortDesc: 'Convert clicks into customers with funnel-based performance strategies for online stores.',
    metaTitle: 'Ecommerce Development Services In Ramamurthy Nagar | Cyborgsapient Pvt. Ltd.',
    metaDescription: 'Looking for an ecommerce website development company in Ramamurthy Nagar? Cyborgsapient Pvt. Ltd. delivers custom ecommerce solutions that drive sales and growth.',
    keywords: 'Ecommerce Development Services in bangalore, ecommerce development services in ramamurthy nagar, website development company Bangalore, website development company Ramamurthy Nagar, ecommerce website development company in ramamurthy nagar',
    icon: 'FaShoppingCart',
    problem: 'High traffic but low conversions? Your e-commerce store needs conversion-optimized marketing strategies.',
    solution: 'Our e-commerce marketing services focus on the entire customer journey, from acquisition to conversion and retention.',
    features: [
      'Conversion Rate Optimization',
      'Shopping Campaign Management',
      'Product Feed Optimization',
      'Abandoned Cart Recovery',
      'Customer Retention Strategies',
      'Multi-channel Integration',
      'Performance Analytics'
    ],
    results: 'Average 30-50% increase in conversion rates and 2-3x improvement in customer lifetime value.',
    industryFocus: ['Fashion', 'Electronics', 'Home & Garden', 'Beauty', 'Food & Beverage']
  },
  {
    id: 'ui-ux-design',
    slug: 'ui-ux-design',
    title: 'UI/UX & Graphic Design',
    shortDesc: 'Design interfaces and graphics that engage users and align with your product vision.',
    metaTitle: 'Best UI/UX Designer Services In Ramamurthy Nagar | UI/UX Web Development Services',
    metaDescription: 'Looking for an ecommerce website development company in Ramamurthy Nagar? Cyborgsapient Pvt. Ltd. delivers custom ecommerce solutions that drive sales and growth.',
    keywords: 'Best UI/UX Designer Services in bangalore, best ui ux designer services in ramamurthy nagar, ui ux web development services ramamurthy nagar, website development company Bangalore, website development company Ramamurthy Nagar',
    icon: 'FaPaintBrush',
    problem: 'Poor user experience drives customers away. Your design needs to be both beautiful and functional.',
    solution: 'Our design team creates user-centered interfaces that combine aesthetic appeal with intuitive functionality to improve engagement and conversions.',
    features: [
      'User Research & Analysis',
      'Wireframing & Prototyping',
      'UI Design & Development',
      'Brand Identity Design',
      'Responsive Design',
      'Design System Creation',
      'Usability Testing'
    ],
    results: 'Average 40-60% improvement in user engagement and 25-35% increase in conversion rates.',
    industryFocus: ['SaaS', 'E-commerce', 'Healthcare', 'Finance', 'Education']
  },
  {
    id: 'social-media-development',
    slug: 'social-media-development',
    title: 'Social Media Development',
    shortDesc: 'Build a loyal online community with unique visual storytelling and social strategy.',
    metaTitle: 'Best Social Media Marketing Services In Ramamurthy Nagar | Best Social Media Marketing Agency',
    metaDescription: 'Cyborgsapient Pvt. Ltd. is a leading social media marketing company in Ramamurthy Nagar, helping brands grow with strategic content, ads, and audience engagement.',
    keywords: 'Social Media Marketing Company in Bangalore, social media marketing Bangalore, social media marketing Ramamurthy Nagar, best social media marketing services in ramamurthy nagar, best social media marketing agency ramamurthy nagar',
    icon: 'FaHashtag',
    problem: 'Inconsistent social media presence fails to build meaningful connections with your audience.',
    solution: 'We develop comprehensive social media strategies that combine content creation, community management, and data-driven optimization.',
    features: [
      'Social Media Strategy',
      'Content Creation & Planning',
      'Community Management',
      'Influencer Partnerships',
      'Paid Social Campaigns',
      'Social Listening & Analytics',
      'Crisis Management'
    ],
    results: 'Average 3-5x increase in follower growth and 50-100% improvement in engagement rates.',
    industryFocus: ['Fashion', 'Food & Beverage', 'Entertainment', 'Beauty', 'Technology']
  },
  {
    id: 'software-development',
    slug: 'software-development',
    title: 'Software Development',
    shortDesc: 'Build scalable digital products, from mobile apps to full-stack enterprise systems.',
    metaTitle: 'Software Development Company In Ramamurthy Nagar | Custom Software Development Company',
    metaDescription: 'Cyborgsapient Pvt. Ltd. is a trusted software development company in Ramamurthy Nagar, delivering custom software solutions to drive business growth and innovation.',
    keywords: 'Web Development Company in bangalore, website development company Bangalore, website development company Ramamurthy Nagar, app development company Bangalore, app development company Ramamurthy Nagar, software development company in ramamurthy nagar, custom software development company ramamurthy nagar',
    icon: 'FaCode',
    problem: 'Off-the-shelf solutions don\'t fit your unique business needs. You need custom software that scales.',
    solution: 'Our development team builds scalable, secure, and user-friendly software solutions tailored to your specific business requirements.',
    features: [
      'Custom Web Application Development',
      'Mobile App Development',
      'API Development & Integration',
      'Database Design',
      'Cloud Infrastructure Setup',
      'Security Implementation',
      'Maintenance & Support'
    ],
    results: 'Deliver scalable solutions that improve operational efficiency by 30-50% and support business growth.',
    industryFocus: ['Healthcare', 'Finance', 'Logistics', 'Education', 'Manufacturing']
  }
];

// Helper function to get service by slug
export const getServiceBySlug = (slug) => {
  return servicesData.find(service => service.slug === slug);
};

// Helper function to get all service slugs for routing
export const getAllServiceSlugs = () => {
  return servicesData.map(service => service.slug);
};
